import React from 'react';
export const ProcessPage = () => {
  return <div className="w-full bg-white" data-id="element-177">
      {/* Process Header */}
      <section className="text-center py-20 bg-white" data-id="element-178">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-179">
          <div className="text-green-600 font-semibold text-base uppercase tracking-wider mb-5" data-id="element-180">
            OUR PROCESS
          </div>
          <h2 className="text-5xl font-bold text-[#2c3e50] mb-5" data-id="element-181">
            How We'll Work Together
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-182">
            A structured approach to creating copy that connects and converts.
          </p>
        </div>
      </section>
      {/* Main Process Steps */}
      <section className="bg-white py-16 mb-10" data-id="element-183">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-184">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10" data-id="element-185">
            <div className="text-center bg-gray-50 p-8 rounded-3xl transition-all duration-300 hover:-translate-y-2 hover:shadow-xl" data-id="element-186">
              <div className="w-16 h-16 bg-green-600 text-white rounded-full flex items-center justify-center text-2xl font-bold mx-auto mb-5" data-id="element-187">
                1
              </div>
              <div className="text-5xl mb-5" data-id="element-188">🔍</div>
              <h3 className="text-xl font-bold text-[#2c3e50] mb-4" data-id="element-189">
                Discovery
              </h3>
              <p className="text-gray-600 mb-4" data-id="element-190">
                We start with a deep dive into your business, audience, and
                goals to understand what makes your brand unique.
              </p>
            </div>
            <div className="text-center bg-gray-50 p-8 rounded-3xl transition-all duration-300 hover:-translate-y-2 hover:shadow-xl" data-id="element-191">
              <div className="w-16 h-16 bg-green-600 text-white rounded-full flex items-center justify-center text-2xl font-bold mx-auto mb-5" data-id="element-192">
                2
              </div>
              <div className="text-5xl mb-5" data-id="element-193">📊</div>
              <h3 className="text-xl font-bold text-[#2c3e50] mb-4" data-id="element-194">
                Research
              </h3>
              <p className="text-gray-600 mb-4" data-id="element-195">
                We analyze your competitors, industry trends, and target
                audience to craft messaging that stands out.
              </p>
            </div>
            <div className="text-center bg-gray-50 p-8 rounded-3xl transition-all duration-300 hover:-translate-y-2 hover:shadow-xl" data-id="element-196">
              <div className="w-16 h-16 bg-green-600 text-white rounded-full flex items-center justify-center text-2xl font-bold mx-auto mb-5" data-id="element-197">
                3
              </div>
              <div className="text-5xl mb-5" data-id="element-198">✍️</div>
              <h3 className="text-xl font-bold text-[#2c3e50] mb-4" data-id="element-199">
                Creation
              </h3>
              <p className="text-gray-600 mb-4" data-id="element-200">
                Using proven copywriting frameworks, we develop compelling
                content tailored to your specific needs and objectives.
              </p>
            </div>
            <div className="text-center bg-gray-50 p-8 rounded-3xl transition-all duration-300 hover:-translate-y-2 hover:shadow-xl" data-id="element-201">
              <div className="w-16 h-16 bg-green-600 text-white rounded-full flex items-center justify-center text-2xl font-bold mx-auto mb-5" data-id="element-202">
                4
              </div>
              <div className="text-5xl mb-5" data-id="element-203">✨</div>
              <h3 className="text-xl font-bold text-[#2c3e50] mb-4" data-id="element-204">
                Refinement
              </h3>
              <p className="text-gray-600 mb-4" data-id="element-205">
                After your review, we fine-tune the copy until it perfectly
                captures your voice and achieves your goals.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Enhanced Features */}
      <section className="py-20 bg-gradient-to-r from-[#667eea] to-[#764ba2] text-white" data-id="element-206">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-207">
          <div className="text-center mb-16" data-id="element-208">
            <h2 className="text-4xl font-bold mb-5" data-id="element-209">
              Why Clients Love Working With Us
            </h2>
            <p className="text-xl opacity-90" data-id="element-210">
              Beyond great copy, you get an exceptional experience.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10" data-id="element-211">
            <div className="bg-white bg-opacity-10 backdrop-filter backdrop-blur-lg border border-white border-opacity-20 rounded-3xl p-10 text-center transition-transform duration-300 hover:-translate-y-2" data-id="element-212">
              <div className="text-5xl mb-5" data-id="element-213">💬</div>
              <h3 className="text-2xl font-bold mb-4" data-id="element-214">Direct Communication</h3>
              <p className="opacity-90 leading-relaxed" data-id="element-215">
                Work directly with my team and I, every step of the way. Get
                same-day responses and regular progress updates.
              </p>
            </div>
            <div className="bg-white bg-opacity-10 backdrop-filter backdrop-blur-lg border border-white border-opacity-20 rounded-3xl p-10 text-center transition-transform duration-300 hover:-translate-y-2" data-id="element-216">
              <div className="text-5xl mb-5" data-id="element-217">🔄</div>
              <h3 className="text-2xl font-bold mb-4" data-id="element-218">Unlimited Revisions</h3>
              <p className="opacity-90 leading-relaxed" data-id="element-219">
                We'll refine your copy until it's exactly what you envisioned.
                No extra charges, no questions asked.
              </p>
            </div>
            <div className="bg-white bg-opacity-10 backdrop-filter backdrop-blur-lg border border-white border-opacity-20 rounded-3xl p-10 text-center transition-transform duration-300 hover:-translate-y-2" data-id="element-220">
              <div className="text-5xl mb-5" data-id="element-221">📈</div>
              <h3 className="text-2xl font-bold mb-4" data-id="element-222">Performance Focus</h3>
              <p className="opacity-90 leading-relaxed" data-id="element-223">
                Every word is chosen to drive results. We track performance and
                optimize for maximum ROI.
              </p>
            </div>
            <div className="bg-white bg-opacity-10 backdrop-filter backdrop-blur-lg border border-white border-opacity-20 rounded-3xl p-10 text-center transition-transform duration-300 hover:-translate-y-2" data-id="element-224">
              <div className="text-5xl mb-5" data-id="element-225">🎯</div>
              <h3 className="text-2xl font-bold mb-4" data-id="element-226">Custom Strategy</h3>
              <p className="opacity-90 leading-relaxed" data-id="element-227">
                No templates here. Everything is custom-built for YOUR audience
                and business goals.
              </p>
            </div>
            <div className="bg-white bg-opacity-10 backdrop-filter backdrop-blur-lg border border-white border-opacity-20 rounded-3xl p-10 text-center transition-transform duration-300 hover:-translate-y-2" data-id="element-228">
              <div className="text-5xl mb-5" data-id="element-229">⚡</div>
              <h3 className="text-2xl font-bold mb-4" data-id="element-230">Fast Turnaround</h3>
              <p className="opacity-90 leading-relaxed" data-id="element-231">
                Get your copy faster without sacrificing quality. Most projects
                completed in 7-12 days.
              </p>
            </div>
            <div className="bg-white bg-opacity-10 backdrop-filter backdrop-blur-lg border border-white border-opacity-20 rounded-3xl p-10 text-center transition-transform duration-300 hover:-translate-y-2" data-id="element-232">
              <div className="text-5xl mb-5" data-id="element-233">🤝</div>
              <h3 className="text-2xl font-bold mb-4" data-id="element-234">Partnership Mindset</h3>
              <p className="opacity-90 leading-relaxed" data-id="element-235">
                We're invested in your success. When you win, we also win, and
                we'll go the extra mile to ensure results.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Timeline Section */}

      {/* Guarantee Section */}
      <section className="py-16 bg-[#000000] text-white text-center" data-id="element-236">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-237">
          <div className="max-w-2xl mx-auto" data-id="element-238">
            <div className="inline-flex items-center gap-4 bg-green-600 px-8 py-4 rounded-full font-semibold text-lg transition-all duration-300 hover:-translate-y-1 hover: shadow-lg mb-6" data-id="element-239">
              <span data-id="element-240">🛡️</span>
              100% Satisfaction Guarantee
            </div>
            <p className="text-xl opacity-90 leading-relaxed" data-id="element-241">
              If you're not completely happy with your copy, I'll revise it
              until you love it. Your success is my success.
            </p>
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="py-16 bg-white-600 text-black text-center" data-id="element-242">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-243">
          <h2 className="text-4xl font-bold mb-5" data-id="element-244">Ready to Get Started?</h2>
          <p className="text-xl opacity-90 mb-8" data-id="element-245">
            Let's create copy that turns your visitors into customers
          </p>
          <a href="https://calendly.com/mayhave/30min" className="inline-flex items-center gap-4 bg-green-600 px-8 py-4 text-white px-10 py-4 rounded-full font-semibold text-lg transition-all duration-300 hover:-translate-y-1 hover: shadow-lg mb-6" data-id="element-246">
            Book Your Strategy Call
          </a>
        </div>
      </section>
    </div>;
};